const firebaseConfig = {
    apiKey: "AIzaSyDv9jMg7oGymtO8VxXCbMxmwFLy4UKBx2M",
    authDomain: "hr-global-library.firebaseapp.com",
    projectId: "hr-global-library",
    storageBucket: "hr-global-library.appspot.com",
    messagingSenderId: "45749787825",
    appId: "1:45749787825:web:7009818353bda7a8829690"
  };
export default firebaseConfig;